import { render, staticRenderFns } from "./unsubscribeemail.vue?vue&type=template&id=c82c9654&"
import script from "./unsubscribeemail.vue?vue&type=script&lang=js&"
export * from "./unsubscribeemail.vue?vue&type=script&lang=js&"
import style0 from "./unsubscribeemail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "unsubscribeemail.vue"
export default component.exports